import React, { useEffect, useState } from "react";
import { Form, Input, Button, message, Row, Col, Card, Select } from "antd";
import { motion } from "framer-motion";
import styles from './OtherPages.module.css';
import { categories, getTranslation } from "../../util/utilFunc";
import { useSelector } from "react-redux";
import ProjectServices from "../../services/projectServices";
import { Link, useLocation } from "react-router-dom";
import { FiCheckCircle } from "react-icons/fi";
import { getErrorMessage } from "../../util/GetError";
import { themeOptions } from "../../util/theme";

const { Option } = Select;


const RedirectForm = () => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isAddingThemes, setIsAddingThemes] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedThemes, setSelectedThemes] = useState([]);
  const [basicDetails, setBasicDetails] = useState("");
  const { language } = useSelector(state => state.auth);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [screen, setScreen] = useState(1);
  const [selectedThemeClass, setSelectedThemeClass] = useState('pink__theme');

  const [coreData, setCoreData] = useState([]);
  const [form] = Form.useForm();
  const userId = queryParams.get('user_id');

  async function fetchThemes() {
    try {
      const response = await ProjectServices.getDefaultTemplateData();
      if (response.data) {
        setCoreData(response.data);
      }
    } catch (Err) {
      message.error(getErrorMessage(Err));
    }
  }

  useEffect(() => {
    fetchThemes();
  }, []);

  const onFinish = async (values) => {
    if (!userId) {
      message.error(getTranslation("No User Id Found!", language));
      return;
    }
    if (screen === 1) {
      if (values.password !== values.confirmPassword) {
        message.warning(getTranslation("Your Confirmed Password do not match with Original Password!", language))
        return;
      }
      setBasicDetails({
        password: values.password,
        categories: selectedCategories
      });
      setScreen(2);
      return;
    }
    setLoading(true);

    try {
      let data = {
        ...basicDetails,
        strategicThemes: { coreThemes: selectedThemes, additionalThemes: values.customThemes }
      }
      //console.log(data);
      const response = await ProjectServices.createCompleteProfile(userId, data);

      if (response.data) {
        message.success(getTranslation("Thank you! Your profile info updated!", language));
        setSubmitted(true);
      }
    } catch (error) {
      console.error("Error sending request: ", error);
      message.error(getTranslation("Failed to submit your request. Please try again.", language));
    } finally {
      setLoading(false);
    }
  };

  const handleCategorySelect = (value) => {
    setSelectedCategories(prev => {
      if (prev.includes(value)) {
        return prev.filter(item => item !== value); // Deselect category
      }
      return [...prev, value]; // Select category
    });
  };

  const handleThemeSelect = (theme) => {
    setSelectedThemes((prevSelected) =>
      prevSelected.includes(theme)
        ? prevSelected.filter((item) => item !== theme)
        : [...prevSelected, theme]
    );
  };


  const getFilteredThemeOptions = (assignedThemes) => {
    if (!themeOptions && themeOptions?.length === 0) {
      return;
    }
    return Object.keys(themeOptions)
      .filter((key) => !assignedThemes.includes(key))
      .map((key) => (
        <Option key={key} value={key}>
          {themeOptions[key]}
        </Option>
      ));
  };

  return (
    <div className={styles.bg__primary}>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        style={{ boxShadow: '0 0.344px 6px gray' }}
        className={styles.contact__form}
      >
        {!submitted ?
          screen === 1 ? (
            <>
              <h2>{getTranslation("Explore Compelion with us!", language)}</h2>
              <p>{getTranslation("To help determine your designation and role, please provide the following details.", language)}</p>
              <Form layout="vertical" onFinish={onFinish}>
                <Row gutter={16}>
                  <Col xs={24}>
                    <Form.Item
                      label={getTranslation("Password", language)}
                      name="password"
                      rules={[{ required: true, message: getTranslation("Please enter your password", language) }]}
                    >
                      <Input.Password placeholder={getTranslation("Create a Password", language)} />
                    </Form.Item>

                  </Col>
                  <Col xs={24}>
                    <Form.Item
                      label={getTranslation("Confirm Password", language)}
                      name="confirmPassword"
                      rules={[{ required: true, message: getTranslation("Please confirm your password", language) }]}
                    >
                      <Input.Password placeholder={getTranslation("Confirm your Password", language)} />
                    </Form.Item>

                  </Col>
                  <Col xs={24}>
                    <Form.Item label={getTranslation("Role Categories", language)} required>
                      <Row gutter={[16, 16]}>
                        {categories.map(category => (
                          <Col xs={24} sm={24} md={12} lg={12} key={category.value}>
                            <Card
                              hoverable
                              style={{ cursor: 'pointer', border: selectedCategories.includes(category.value) ? '2px solid #1890ff' : '1px solid #d9d9d9' }}
                              onClick={() => handleCategorySelect(category.value)}
                            >
                              <b style={{ textAlign: 'center' }}>{category.label}</b><br />
                              <small>{category.desc}</small>
                            </Card>
                          </Col>
                        ))}
                      </Row>
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item>
                  <Button type="primary" htmlType="submit" loading={loading}>
                    {getTranslation("Next", language)}
                  </Button>
                </Form.Item>
              </Form>
            </>
          ) : (
            <>
              {isAddingThemes ?

                <>
                  <h2>{getTranslation("Strategic Themes", language)}</h2>
                  <p>{getTranslation("Your strategic vision is the driving force behind every innovation, project, and success.", language)}</p>
                  <Row gutter={12}>
                    <Col span={24}>
                      <Card title={getTranslation("Core Strategic Themes", language)} bordered={false}>
                        <Row gutter={[16, 16]}>
                          {coreData?.strategicTheme?.map((item) => (
                            <Col xs={24} sm={12} md={8} key={item?.id} style={{ display: 'flex' }}>
                              <Card
                                hoverable
                                style={{
                                  border: selectedThemes.includes(item?.strategicTheme) ? '2px solid #1890ff' : '1px solid #ccc',
                                  textAlign: 'center',
                                  flex: 1,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  justifyContent: 'center',
                                }}
                                onClick={() => handleThemeSelect(item?.strategicTheme)}
                              >
                                {item?.strategicTheme}
                              </Card>
                            </Col>
                          ))}
                        </Row>
                      </Card>
                    </Col>

                    <Col span={24}>
                      <Form onFinish={onFinish} form={form} layout="vertical">
                        <Card title={getTranslation("Custom Strategic Themes", language)} bordered={false}>
                          <Form.List name="customThemes">
                            {(fields, { add, remove }) => (
                              <>
                                {fields.map(({ key, name, fieldKey, ...restField }, i) => (
                                  <Row gutter={8} key={key} justify="center" align="middle">
                                    <Col span={10}>
                                      <Form.Item
                                        {...restField}
                                        name={[name, "customTheme"]}
                                        fieldKey={[fieldKey, "customTheme"]}
                                        label={getTranslation("Custom Strategic Theme", language)}
                                        rules={[{ required: true, message: getTranslation("Please enter a theme", language) }]}
                                      >
                                        <Input placeholder={getTranslation("Add custom strategic theme", language)} />
                                      </Form.Item>
                                    </Col>
                                    <Col span={10}>
                                      <Form.Item
                                        {...restField}
                                        label={getTranslation("Theme Class", language)}
                                        name={[name, "themeClass"]}
                                        fieldKey={[fieldKey, "themeClass"]}
                                        rules={[{ required: true, message: getTranslation("Please select a theme class", language) }]}
                                      >
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                          <div
                                            className={selectedThemeClass[name] || ''}
                                            style={{
                                              width: '20px',
                                              height: '20px',
                                              marginRight: '10px',
                                              border: '1px solid #ccc',
                                            }}
                                          ></div>
                                          <Select
                                            placeholder={getTranslation("Select Theme Class", language)}
                                            onChange={(value) => {
                                              const newThemes = [...selectedThemeClass];
                                              newThemes[name] = value;
                                              setSelectedThemeClass(newThemes); // Track state individually for each item
                                              // Retrieve the current customThemes array from the form
                                              const currentCustomThemes = form.getFieldValue("customThemes") || [];

                                              // Update only the themeClass for the specific item
                                              const updatedCustomThemes = currentCustomThemes.map((item, index) =>
                                                index === name ? { ...item, themeClass: value } : item
                                              );

                                              // Set the updated array back to form
                                              form.setFieldsValue({ customThemes: updatedCustomThemes });

                                            }}
                                          >
                                            {getFilteredThemeOptions(
                                              coreData?.strategicTheme?.map((theme) => theme.themeClass)
                                            )}
                                          </Select>
                                        </div>
                                      </Form.Item>
                                    </Col>
                                    <Col span={4}>

                                      <Button onClick={() => remove(name)}>-</Button>
                                    </Col>
                                  </Row>
                                ))}
                                <Form.Item>
                                  <Button type="dashed" onClick={() => add()}>
                                    {getTranslation("+ Add Custom Theme", language)}

                                  </Button>
                                </Form.Item>
                              </>
                            )}
                          </Form.List>
                          <Form.Item>

                            <Button type="primary" htmlType="submit" loading={loading}>
                              {getTranslation("Submit", language)}
                            </Button>
                          </Form.Item>
                        </Card>
                      </Form>
                    </Col>
                  </Row>
                </>

                :

                <div className={styles.info__Wrapper}>
                  <h2>{getTranslation("Would you like to Add Strategic Themes Info?", language)}</h2>
                  <div className={styles.btn__wrapper}>
                    <Button size="large" onClick={onFinish}>{getTranslation("Skip For Now!", language)}</Button>
                    <Button size="large" style={{ marginLeft: "10px" }} type="primary" onClick={() => setIsAddingThemes(true)}>{getTranslation("Yes, Let's Do It!", language)}</Button>
                  </div>

                </div>


              }
            </>
          ) : (
            <div style={{ textAlign: "center", padding: 20 }}>
              <div>
                <FiCheckCircle style={{ fontSize: "5rem", color: "#52c41a" }} />
              </div>
              <h3>{getTranslation("Thank you for your submission!", language)}</h3>
              <p>{getTranslation("Please Login to your account now to explore Compelion!", language)}</p>
              <Link to="/login" className="primaryBtn">{getTranslation("Login", language)}</Link>
            </div>
          )}
      </motion.div>
    </div>
  );
};

export default RedirectForm;
